import {
  FeatureFlagsModel,
  featureFlagsVersionType,
} from '@/features/feature-flag/_models/feature-flags';
import { z } from 'zod';

export const devToolsLocalStorageKey = z.enum(['feature-flags', 'favorite']);

const userId = z.string().uuid();

export const FeatureFlagsLocalStorageValueSchema = FeatureFlagsModel.extend({
  enabled: z.boolean(),
  version: featureFlagsVersionType,
});
export const FeatureFlagsLocalStorageSchema = z.record(
  userId,
  FeatureFlagsLocalStorageValueSchema,
);

export const FavoriteItemSchema = z.object({
  id: z.string().uuid(),
  url: z.string().url(),
  title: z.string().min(1),
  notes: z.string().optional(),
});

export const FavoritesSchema = z.array(FavoriteItemSchema);
